import {makeStorageWrapper} from "./makeStorageWrapper";

const getLocalStorage = () => typeof window !== 'undefined' ? localStorage : null;

export const ReactLocalStorage = makeStorageWrapper(getLocalStorage(), "localStorage");